/* eslint-disable max-len */
import React from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import logoEu from '../../images/logo-eu.png';
import logoDfp from '../../images/funzione-pubblica.svg';

function FooterHtml() {
  return (
    <footer id="footer">
      <div className="container px-5">
        <section className="footer-logo">
          <div className="row clearfix">
            <div className="col-sm-12 intestazione">
              <div className="logo-long mb-3">
                <img height="70px" className="me-3 mb-3" src={logoEu} alt="Logo Next Generation EU" />
                <img height="70px" className="me-3 mb-3" src={logoDfp} alt="Logo DFP" />
              </div>
            </div>
          </div>
        </section>
        <section className="lista-linkutili">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-8 footer-contatti">
              <p id="title">
                CONTATTI
              </p>
              <p>
                <strong>Ministro per la Pubblica amministrazione</strong>
                <br />
                Corso Vittorio Emanuele II - 00186 Roma
              </p>
              <p>
                <strong>Dipartimento della Funzione Pubblica</strong>
                <br />
                Corso Vittorio Emanuele II - 00186 Roma
              </p>
              <p>
                <strong>Informazioni</strong>
                <br />
                <a className="text-white" href="mailto:progetto-minerva@dfp.gov.it">progetto-minerva@dfp.gov.it</a>
              </p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-8 footer-contatti">
              <p id="title">
                MAPPA DEL SITO
              </p>
              <p>
                <Link className="text-white" to="/programmazione-personale" title="Vai alla pagina: Programmazione del personale">
                  Programmazione del Personale
                </Link>
              </p>
              <p>
                <Link className="text-white" to="/sistema-professionale" title="Vai alla pagina: Sistema Professionale">
                  Sistema Professionale
                </Link>
              </p>
              <p>
                <Link className="text-white" to="/area-amministrazioni" title="Vai alla pagina: Area Amministrazioni">
                  Area Amministrazioni
                </Link>
              </p>
              <p>
                <Link className="text-white" to="/approfondimenti" title="Vai alla pagina: Approfondimenti">
                  Approfondimenti
                </Link>
              </p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-8 footer-contatti">
              <p id="title">
                SUPPORTO
              </p>
              <p>
                <strong>FAQ</strong>
                <br />
                <Link className="text-white" to="/faq" title="Vai alla pagina: FAQ - Domande e risposte">FAQ - Domande e risposte</Link>
              </p>
            </div>
            {/* <div className="col-lg-3 col-md-3 col-sm-6 footer-seguici">
              <p id="title">SEGUICI SU</p>
              <ul className="list-inline text-start social">
                <li className="list-inline-item">
                  <a
                    href="https://www.facebook.com/DipartimentoFunzionePubblica"
                    target="_blank"
                    title="Collegamento a sito esterno - Facebook - si apre una nuova finestra"
                    rel="noreferrer"
                    aria-label="Facebook"
                  >
                    <FontAwesomeIcon aria-hidden="true" icon={['fab', 'facebook']} color="white" size="lg" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href="https://twitter.com/FunzPub"
                    target="_blank"
                    title="Collegamento a sito esterno - Twitter - si apre una nuova finestra"
                    rel="noreferrer"
                    aria-label="Twitter"
                  >
                    <FontAwesomeIcon aria-hidden="true" icon={['fab', 'x-twitter']} color="white" size="lg" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href="https://www.instagram.com/dipartimento_funzione_pubblica/"
                    target="_blank"
                    title="Collegamento a sito esterno - Instagram - si apre una nuova finestra"
                    rel="noreferrer"
                    aria-label="Instagram"
                  >
                    <FontAwesomeIcon aria-hidden="true" icon={['fab', 'instagram']} size="lg" color="white" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href="https://www.youtube.com/channel/UCIGLJG5C6ghZp-V-AgWwGCg"
                    target="_blank"
                    title="Collegamento a sito esterno - Youtube - si apre una nuova finestra"
                    rel="noreferrer"
                    aria-label="YouTube"
                  >
                    <FontAwesomeIcon aria-hidden="true" icon={['fab', 'youtube']} color="white" size="lg" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href="https://it.linkedin.com/company/dipartimento-della-funzione-pubblica"
                    target="_blank"
                    title="Collegamento a sito esterno - LinkedIn - si apre una nuova finestra"
                    rel="noreferrer"
                    aria-label="LinkedIn"
                  >
                    <FontAwesomeIcon aria-hidden="true" icon={['fab', 'linkedin']} color="white" size="lg" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href="https://web.telegram.org/#/im?p=@funzionepubblica"
                    target="_blank"
                    title="Collegamento a sito esterno - Telegram - si apre una nuova finestra"
                    rel="noreferrer"
                    aria-label="Telegram"
                  >
                    <FontAwesomeIcon aria-hidden="true" icon={['fab', 'telegram']} size="lg" color="white" />
                  </a>
                </li>
              </ul>
            </div> */}
          </div>
        </section>

      </div>
      <div className="postFooter clearfix" style={{ backgroundColor: '#000000' }}>
        <div className="container px-5">

          <div className="link_piede_footer">
            <Link
              className="text-white"
              to="/privacy-policy"
              title="Privacy policy"
              aria-label="Vai alla pagina: Privacy policy"
              style={{
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: '16px',
                // textTransform: 'uppercase',
                marginRight: '24px',
              }}
            >
              Privacy Policy
            </Link>

            <a
              className="text-white"
              href="https://www.lavoropubblico.gov.it/note-legali"
              target="_blank"
              title="Collegamento a sito esterno - Note legali - si apre nuova pagina"
              rel="noreferrer"
              aria-label="Vai alla pagina: Note legali"
              style={{
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: '16px',
                // textTransform: 'uppercase',
                marginRight: '24px',
              }}
            >
              Note Legali
            </a>

            <a
              className="text-white"
              href="https://form.agid.gov.it/PCM/portale_minerva/dichiarazione"
              target="_blank"
              title="Vai alla pagina: Dichiarazione di accessibilità"
              aria-label="Vai alla pagina: Dichiarazione di accessibilità"
              rel="noreferrer"
              style={{
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: '16px',
                // textTransform: 'uppercase',
                marginRight: '24px',
              }}
            >
              Dichiarazione di Accessibilità
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterHtml;
